var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperatingAgreement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 260,
    viewBox: "0 0 241 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.423,
    cy: 139.316,
    r: 120,
    fill: "#EAF1FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_3537_6750)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.423,
    cy: 94.2148,
    r: 92.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2357 66.0664H217.236C219.673 66.0664 221.611 68.0039 221.611 70.4414V187.066C221.611 189.504 219.673 191.441 217.236 191.441H30.2357C27.7982 191.441 25.8607 189.504 25.8607 187.066V70.4414C25.8607 68.0039 27.7982 66.0664 30.2357 66.0664Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.486 191.816H31.9857C28.3607 191.816 25.4232 188.879 25.4232 185.254V72.1289C25.4232 68.5039 28.3607 65.5664 31.9857 65.5664H215.486C219.111 65.5664 222.048 68.5039 222.048 72.1289V185.254C222.048 188.879 219.111 191.816 215.486 191.816ZM31.9857 66.5039C28.8607 66.5039 26.2982 69.0664 26.2982 72.1914V185.316C26.2982 188.441 28.8607 191.004 31.9857 191.004H215.486C218.611 191.004 221.173 188.441 221.173 185.316V72.1914C221.173 69.0664 218.611 66.5039 215.486 66.5039H31.9857Z",
    fill: "#01060B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.611 172.004H25.8607C25.6107 172.004 25.4232 171.816 25.4232 171.566C25.4232 171.316 25.6107 171.129 25.8607 171.129H221.611C221.861 171.129 222.048 171.316 222.048 171.566C222.048 171.816 221.861 172.004 221.611 172.004Z",
    fill: "#01060B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.736 215.629H98.7358L107.923 191.441H139.548L148.736 215.629Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.736 216.066H98.6732C98.5482 216.066 98.4232 216.004 98.2982 215.879C98.2357 215.754 98.1732 215.629 98.2357 215.504L107.486 191.254C107.548 191.066 107.736 190.941 107.861 190.941H139.423C139.611 190.941 139.736 191.066 139.798 191.254L149.048 215.504C149.111 215.629 149.048 215.816 148.986 215.879C148.986 216.004 148.861 216.066 148.736 216.066ZM99.3607 215.191H148.111L139.236 191.816H108.236L99.3607 215.191Z",
    fill: "#01060B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9858 214.254H155.423C156.611 214.254 157.548 215.191 157.548 216.379V218.754C157.548 219.941 156.611 220.879 155.423 220.879H91.9858C90.7983 220.879 89.8608 219.941 89.8608 218.754V216.379C89.9233 215.129 90.8608 214.254 91.9858 214.254Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.611 221.191H92.7981C90.9231 221.191 89.4231 219.691 89.4231 217.816V217.129C89.4231 215.254 90.9231 213.754 92.7981 213.754H154.611C156.486 213.754 157.986 215.254 157.986 217.129V217.816C157.986 219.691 156.486 221.191 154.611 221.191ZM92.8606 214.629C91.4856 214.629 90.3606 215.754 90.3606 217.129V217.816C90.3606 219.191 91.4856 220.316 92.8606 220.316H154.673C156.048 220.316 157.173 219.191 157.173 217.816V217.129C157.173 215.754 156.048 214.629 154.673 214.629H92.8606Z",
    fill: "#01060B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.361 202.504L140.611 195.254L139.173 191.441H107.611L103.361 202.504Z",
    fill: "#01060B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.361 202.941C103.236 202.941 103.111 202.879 103.048 202.816C102.923 202.691 102.923 202.504 102.986 202.379L107.173 191.316C107.236 191.129 107.423 191.004 107.548 191.004H139.111C139.298 191.004 139.423 191.129 139.486 191.316L140.923 195.129C140.986 195.379 140.923 195.629 140.673 195.691H140.611L103.361 202.941ZM107.861 191.879L104.048 201.941L140.048 195.004L138.861 191.941L107.861 191.879Z",
    fill: "#01060B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M214.673 71.9414H32.8607V163.879H214.673V71.9414Z",
    fill: "#2977CC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M214.673 71.9414H32.8607V163.879H214.673V71.9414Z",
    fill: "#E6E6E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M189.986 50.3789V163.941H57.4857V42.8789H182.486C186.673 42.8789 189.986 46.1914 189.986 50.3789Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.986 164.316H57.4857C57.2357 164.316 57.0482 164.129 57.0482 163.879V42.8789C57.0482 42.6289 57.2357 42.4414 57.4857 42.4414H182.486C186.861 42.4414 190.423 46.0039 190.423 50.3789V163.941C190.423 164.129 190.236 164.379 189.986 164.316ZM57.9857 163.441H189.611V50.3164C189.611 46.3789 186.423 43.2539 182.548 43.2539H57.9857V163.441Z",
    fill: "#01060B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.798 130.004H65.8608C65.6108 130.004 65.4233 129.816 65.4233 129.566V88.3164C65.4233 88.0664 65.6108 87.8789 65.8608 87.8789H110.798C111.048 87.8789 111.236 88.0664 111.236 88.3164V129.566C111.236 129.754 111.048 130.004 110.798 130.004ZM66.2983 129.129H110.361V88.6914H66.2983V129.129Z",
    fill: "#D1D3D4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M181.111 157.691H68.4858C68.2358 157.691 68.0483 157.504 68.0483 157.254V137.254C68.0483 137.004 68.2358 136.816 68.4858 136.816H181.111C181.361 136.816 181.548 137.004 181.548 137.254V157.254C181.548 157.504 181.361 157.691 181.111 157.691ZM68.9233 156.816H180.673V137.754H68.9233V156.816Z",
    fill: "#D1D3D4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.111 144.816H68.4858C68.2358 144.816 68.0483 144.629 68.0483 144.379C68.0483 144.129 68.2358 143.941 68.4858 143.941H181.111C181.361 143.941 181.548 144.129 181.548 144.379C181.548 144.566 181.361 144.816 181.111 144.816Z",
    fill: "#D1D3D4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M182.486 42.8789C178.361 42.8789 174.986 46.2539 174.986 50.3789V57.8789H46.8607V50.3789C46.8607 46.2539 50.2357 42.8789 54.3607 42.8789H182.486Z",
    fill: "#2977CC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M174.986 58.3164H46.8607C46.6107 58.3164 46.4232 58.1289 46.4232 57.8789V50.3789C46.4232 46.0039 49.9857 42.4414 54.4232 42.4414H182.548C182.798 42.4414 182.986 42.6289 182.986 42.8789C182.986 43.1289 182.798 43.3164 182.548 43.3164C178.611 43.3164 175.486 46.5039 175.486 50.3789V57.8789C175.423 58.1289 175.236 58.3164 174.986 58.3164ZM47.2982 57.4414H174.548V50.3789C174.548 47.3789 176.236 44.6914 178.861 43.3164H54.3607C50.4232 43.3164 47.2982 46.5039 47.2982 50.3789V57.4414Z",
    fill: "#01060B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M179.173 129.316L179.173 126.191L114.173 126.191L114.173 129.316L179.173 129.316Z",
    fill: "#2977CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.923 122.441L157.923 121.191L114.173 121.191L114.173 122.441L157.923 122.441Z",
    fill: "#2977CC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.298 112.441L132.298 111.191L114.173 111.191L114.173 112.441L132.298 112.441Z",
    fill: "#2977CC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M165.423 117.441L165.423 116.191L114.173 116.191L114.173 117.441L165.423 117.441Z",
    fill: "#D1D3D4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.298 107.441L152.298 106.191L114.173 106.191L114.173 107.441L152.298 107.441Z",
    fill: "#D1D3D4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M162.173 89.5039H152.486V96.8789H162.173V89.5039Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176.736 89.5039H167.048V104.816H176.736V89.5039Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.923 157.691C100.673 157.691 100.486 157.504 100.486 157.254V137.254C100.486 137.004 100.673 136.816 100.923 136.816C101.173 136.816 101.361 137.004 101.361 137.254V157.254C101.361 157.504 101.173 157.691 100.923 157.691Z",
    fill: "#D1D3D4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M153.548 157.691C153.298 157.691 153.111 157.504 153.111 157.254V137.254C153.111 137.004 153.298 136.816 153.548 136.816C153.798 136.816 153.986 137.004 153.986 137.254V157.254C153.986 157.504 153.798 157.691 153.548 157.691Z",
    fill: "#D1D3D4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M175.236 69.2539H139.236C138.986 69.2539 138.798 69.0664 138.798 68.8164C138.798 68.5664 138.986 68.3789 139.236 68.3789H175.173C175.423 68.3789 175.611 68.5664 175.611 68.8164C175.673 69.0664 175.486 69.2539 175.236 69.2539Z",
    fill: "#D1D3D4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M126.029 69.6289H66.1508C65.735 69.6289 65.4231 69.3611 65.4231 69.0039C65.4231 68.6468 65.735 68.3789 66.1508 68.3789H125.925C126.341 68.3789 126.653 68.6468 126.653 69.0039C126.757 69.3611 126.445 69.6289 126.029 69.6289Z",
    fill: "#D1D3D4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M175.236 74.1289H160.548C160.298 74.1289 160.111 73.9414 160.111 73.6914C160.111 73.4414 160.298 73.2539 160.548 73.2539H175.236C175.486 73.2539 175.673 73.4414 175.673 73.6914C175.673 73.9414 175.486 74.1289 175.236 74.1289Z",
    fill: "#D1D3D4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M125.953 74.6289H101.768C101.357 74.6289 101.048 74.3611 101.048 74.0039C101.048 73.6468 101.357 73.3789 101.768 73.3789H125.953C126.364 73.3789 126.673 73.6468 126.673 74.0039C126.673 74.3611 126.364 74.6289 125.953 74.6289Z",
    fill: "#D1D3D4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M154.423 74.1289H139.298C139.048 74.1289 138.861 73.9414 138.861 73.6914C138.861 73.4414 139.048 73.2539 139.298 73.2539H154.423C154.673 73.2539 154.861 73.4414 154.861 73.6914C154.861 73.9414 154.673 74.1289 154.423 74.1289Z",
    fill: "#D1D3D4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5633 74.6289H66.158C65.7381 74.6289 65.4231 74.3611 65.4231 74.0039C65.4231 73.6468 65.7381 73.3789 66.158 73.3789H91.5633C91.9832 73.3789 92.2981 73.6468 92.2981 74.0039C92.2981 74.3611 91.9832 74.6289 91.5633 74.6289Z",
    fill: "#D1D3D4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M175.236 79.0039H143.798C143.548 79.0039 143.361 78.8164 143.361 78.5664C143.361 78.3164 143.548 78.1289 143.798 78.1289H175.236C175.486 78.1289 175.673 78.3164 175.673 78.5664C175.673 78.7539 175.486 79.0039 175.236 79.0039Z",
    fill: "#D1D3D4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M125.945 79.0039H73.6509C73.235 79.0039 72.9231 78.87 72.9231 78.6914C72.9231 78.5128 73.235 78.3789 73.6509 78.3789H125.945C126.361 78.3789 126.673 78.5128 126.673 78.6914C126.673 78.8253 126.361 79.0039 125.945 79.0039Z",
    fill: "#D1D3D4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_3537_6750",
    x: 24.7232,
    y: 0.914844,
    width: 191.4,
    height: 194.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3537_6750"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3537_6750",
    result: "effect2_dropShadow_3537_6750"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_3537_6750",
    result: "effect3_dropShadow_3537_6750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_3537_6750",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatingAgreement);
export default __webpack_public_path__ + "static/media/OperatingAgreement.dad82e7377980cda24c4c86afe557f90.svg";
export { ForwardRef as ReactComponent };